import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { i18n } from "@/i18n";

// You can use the following starter router instead of the default one as a clean starting point
import router from "./router/starter";
//import router from "./router";

import ApiService from "@/core/services/ApiService";

import ElementPlus from "element-plus";
import 'element-plus/dist/index.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import { registerSecurityDirectives } from "@/security/directives";

// Template components
import BaseBlock from "@/components/BaseBlock.vue";
import BaseBackground from "@/components/BaseBackground.vue";
import BasePageHeading from "@/components/BasePageHeading.vue";

// Template directives
import clickRipple from "@/directives/clickRipple";

import { vMaska } from "maska/vue";

// Bootstrap framework
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// Craft new application
const app = createApp(App);

// Register global components
app.component("BaseBlock", BaseBlock);
app.component("BaseBackground", BaseBackground);
app.component("BasePageHeading", BasePageHeading);

// Register global directives
app.directive("click-ripple", clickRipple);

ApiService.init(app);

// Use Pinia and Vue Router
app.use(createPinia());
app.use(router);
app.use(ElementPlus);

app.directive("maska", vMaska);

app.use(i18n);

registerSecurityDirectives(app);

// ..and finally mount it!
app.mount("#app");
